import React from 'react';
import Icon from './Icon';

const Phone = (props) => (
  <Icon viewBox="0 0 19 19" {...props}>
    <title>Phone</title>
    <g id="New-UX" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <g id="My-Account/Rewards" transform="translate(-704.000000, -502.000000)" stroke="#303C42">
        <g id="phone-icon" transform="translate(705.000000, 503.000000)">
          <path d="M3.77777768,7.5555553 C5.13777737,10.2283334 6.77166656,11.8527774 9.44444464,13.2222213 L11.7205552,11.503333 C11.9755553,11.2483319 12.3533334,11.1633328 12.6838893,11.2766665 C13.7416686,11.6261109 14.8844451,11.8149994 16.0555553,11.8149994 C16.5749988,11.8149994 17,12.2399986 17,12.759445 L17,16.0555552 C16.9999999,16.5749989 16.5749988,17 16.0555552,17 C7.18722146,17 0,9.8127775 0,0.9444447 C0,0.425 0.424999997,0 0.944444694,0 L4.24999997,0 C4.76944447,0 5.19444467,0.425 5.19444467,0.9444447 C5.19444467,2.125 5.38333317,3.2583332 5.73277757,4.3161107 C5.83666607,4.6466665 5.76111027,5.0149994 5.49666597,5.2794447 L3.77777768,7.5555553 Z" id="XMLID_1455_"/>
        </g>
      </g>
    </g>
  </Icon>
);

export default Phone;
